import WalkingTest from 'dashboard/templates/views/Encounter/WalkingTest';

export default {
  path: 'walking-test',
  name: 'PatientEncounterWalkingTest',
  component: WalkingTest,
  meta: {
    // title: 'Encounter - Walking Test',
    title: t => t('walkingTest.title'),
    loggedInOnly: true,
  }
};
